import type { CSSProperties } from 'react';
import { typeScale, tracking } from '@viq-admin/ui';

// Shared by every Batch metric tile (`MetricCard`, `ScansGoalCard`), so the
// label, number and caption of each sit at the same heights and the numbers
// line up across a row.

/** Space (px) between a tile's label and its number. */
export const TILE_NUMBER_GAP = 10;

/** Height (px) of a tile's caption line, reserved whether or not it has text. */
export const TILE_CAPTION_LINE = 16;

/**
 * A tile's label: one uppercase line. A label too long for its tile ends in
 * an ellipsis rather than wrapping, because a wrapped label would push that
 * tile's number below its neighbours'.
 */
export function tileLabelStyle(color: string): CSSProperties {
  return {
    fontSize: typeScale.caption,
    fontWeight: 600,
    letterSpacing: tracking.label,
    textTransform: 'uppercase',
    color,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };
}
